import React from 'react';
// import PropTypes from 'prop-types';
import {Redirect, Route} from 'react-router-dom';
import {connect} from 'react-redux'
import {isAuthenticated} from "./store/auth/utils";

const PUBLIC_ROOT = '/login/';
const PACKAGE_ROUTE = '/package/:packageSlug/';

const AuthRoute = ({component, ...props}) => {
    if (props.isAuthenticated) {
        return <Route {...props} component={component}/>;
    }
    else {
        if(props.path === PACKAGE_ROUTE){
            const url = process.env.REACT_APP_WEB_BASE_URL + 'package/' + props.computedMatch.params.packageSlug;
            return <Route path='/' component={() => {
                window.location.href = url;
                return null;
            }}/>
        }
        if (props.path !== PUBLIC_ROOT) {
            return <Redirect to={PUBLIC_ROOT}/>;
        }
        return <Route {...props} component={component}/>;
    }
};


const mapStateToProps = (state) => ({
   'isAuthenticated': isAuthenticated(state.auth)
});

// AuthRoute.propTypes = {
//   component: PropTypes.oneOfType([
//     PropTypes.element,
//     PropTypes.func
//   ])
// };

// export default AuthRoute;
export default connect(mapStateToProps)(AuthRoute)


// WEBPACK FOOTER //
// ./src/AuthRoute.js